import React, { memo, useMemo } from 'react'
import moment from 'moment'
import { ListItem, makeStyles, Typography } from 'transfix-ui/core'
import { IAttachedDocument } from 'types/graphqlTypes'
import FORMATS from 'constants/datetime'

const useLaneAgreementListItemStyles = makeStyles({
  listItem: {
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'column',
  },
  top: {
    fontWeight: 'normal',
  },
})

interface ILaneAgreementListItemProps {
  laneAgreement: Pick<IAttachedDocument, 'id' | 'createdAt' | 'document'>
  shipperRateId: string
}

const LaneAgreementListItem = memo<ILaneAgreementListItemProps>(
  ({ laneAgreement, shipperRateId }) => {
    const classes = useLaneAgreementListItemStyles()

    const { createdAt, document } = laneAgreement ?? {}

    const awardedLaneHref = useMemo(() => `${__ROOT__}/awarded-lanes/${shipperRateId}`, [
      shipperRateId,
    ])

    return (
      <ListItem className={classes.listItem} disableGutters>
        <div className={classes.top}>
          <a className='mr2' href={awardedLaneHref} target='_blank' rel='noopener noreferrer'>
            {shipperRateId}
          </a>

          {document?.url && (
            <a href={document.url} target='_blank' rel='noopener noreferrer'>
              {document?.name}
            </a>
          )}
        </div>

        <Typography color='textSecondary' variant='body2'>
          {moment(createdAt).format(FORMATS.dateFormat)}
        </Typography>
      </ListItem>
    )
  }
)

export default LaneAgreementListItem
